import type { PropsWithChildren, ReactNode } from 'react';

import { AccordionItem } from 'components/Accordion/Item/AccordionItem';
import { Icon } from 'components/Icon/Icon';
import type { IconName } from 'components/Icon/IconName';
import {
  SearchFacetAccordionSummary,
  SearchFacetAccordionSummaryLabel,
} from 'modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem.styled';
import type { SearchRefinementType } from 'modules/search/constants/refinements/searchRefinementTypes';

type Props = {
  facetType: SearchRefinementType;
  label: ReactNode;
  icon?: IconName;
};

export function SearchFilterAccordionItem({
  facetType,
  icon,
  label,
}: PropsWithChildren<Props>) {
  return (
    <AccordionItem
      qaId={`search-facet-accordion-item-${facetType}`}
      name="search-facet"
      header={
        <SearchFacetAccordionSummary>
          <SearchFacetAccordionSummaryLabel>
            {icon ? <Icon size={18} name={icon} /> : undefined}
            <span>{label}</span>
          </SearchFacetAccordionSummaryLabel>
          <div data-facet-type={facetType}>
            <input type="checkbox" name={facetType} />
          </div>
        </SearchFacetAccordionSummary>
      }
    />
  );
}
